/*
 * This hook aims to send event messages within the header component scope.
 * The reasoning behind using Custom Events for something that can also be solved using
 * state management, is to address particular use cases where two components must
 * communicate an event without sharing information irrelevant to the other
 * component's domain. In such cases, using state management (i.e., context, redux)
 * would break the "separation of concerns" design principle.
 *
 * For example:
 * An Account menu item (header domain),
 * opening a Workflow groups management modal (workflow domain).
 */
import { useEffect } from 'react';

export type CustomEventType =
	| 'openWFGroupsModal'
	| 'openOutOfOfficeModal'
	| 'headerFrontend_clearSpotlightInput';

export function useCustomEvent(type: CustomEventType, eventHandler: () => void) {
	useEffect(() => {
		document.addEventListener(type, eventHandler);

		return () => {
			document.removeEventListener(type, eventHandler);
		};
	}, [eventHandler, type]);
}

export function dispatchCustomEvent(type: CustomEventType) {
	const event = new CustomEvent(type);
	document.dispatchEvent(event);
}
